module.exports = __webpack_public_path__ + "img/Q-Studio.feb53eb8.jpg";